// extracted by mini-css-extract-plugin
export default {"editor":"QuillEditor_editor__Pq21u","viewer":"QuillEditor_viewer__T6bdE"};